<div class="container mt-4">
  <div class="row">
    <div class="col-sm-5 pt-3" style="background-color: #f67220">
      <form
        #resetPasswordForm="ngForm"
        (ngSubmit)="submitForm(resetPasswordForm)"
        novalidate
      >
        <div class="pt-5 pl-5">
          <h1>Reset Password</h1>
          <div>
            <label for="newPassword">New Password</label>
            <input
              type="{{ showNewPassword ? 'text' : 'password' }}"
              id="newPassword"
              class="form_filed password-input"
              name="newPassword"
              placeholder="New Password"
              [(ngModel)]="newPassword"
              #newPasswordField="ngModel"
              required
              style="
                position: relative;
                padding-right: 225px;
                line-height: 2.1;
                border-radius: 5px;
                border: 2px solid #ced4da;
                transition: border-color 0.15s ease-in-out,
                  box-shadow 0.15s ease-in-out;
                display: flex;
              "
            />
            <div
              *ngIf="
                newPasswordField.invalid &&
                (newPasswordField.dirty || newPasswordField.touched)
              "
              class="error-message"
            >
              New Password is required
            </div>
            <i
              class="password-icon fas"
              [ngClass]="{
                'fa-eye-slash': !showNewPassword,
                'fa-eye': showNewPassword
              }"
              (click)="toggleNewPasswordVisibility()"
              style="
                position: absolute;
                color: gray;
                top: 166px;
                right: 100px;
                display: flex;
              "
            ></i>
          </div>
          <div>
            <label for="confirmPassword">Confirm Password</label>
            <input
              type="{{ showConfirmPassword ? 'text' : 'password' }}"
              id="confirmPassword"
              class="form_filed password-input"
              name="confirmPassword"
              placeholder="Confirm Password"
              [(ngModel)]="confirmPassword"
              #confirmPasswordField="ngModel"
              required
              style="
                position: relative;
                padding-right: 225px;
                line-height: 2.1;
                border: 2px solid #ced4da;
                border-radius: 5px;
                transition: border-color 0.15s ease-in-out,
                  box-shadow 0.15s ease-in-out;
                border: 1px solid transparent;
                display: flex;
              "
            />
            <div
              *ngIf="
                confirmPasswordField.invalid &&
                (confirmPasswordField.dirty || confirmPasswordField.touched)
              "
              class="error-message"
            >
              Confirm Password is required
            </div>
            <i
              class="password-icon fas"
              [ngClass]="{
                'fa-eye-slash': !showConfirmPassword,
                'fa-eye': showConfirmPassword
              }"
              (click)="toggleConfirmPasswordVisibility()"
              style="
                position: absolute;
                color: gray;
                top: 244px;
                right: 100px;
                display: flex;
              "
            ></i>
          </div>
          <div class="text-center">
            <button
              type="button"
              class="cancel-button"
              (click)="cancel()"
              style="
                background-color: #daa06d;
                font-weight: bold;
                margin-right: 25px;
              "
            >
              Cancel
            </button>
            <button
              type="submit"
              class="submit-button"
              [disabled]="resetPasswordForm.invalid"
            >
              Submit
            </button>
          </div>
          <div *ngIf="successMessage" class="alert alert-success">
            {{ successMessage }}
          </div>
          <div *ngIf="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
